import { Button, Dropdown, Tab, Table, Tabs } from "react-bootstrap";
import { useEffect, useMemo, useState } from "react";
import "./invertoryorderlist.scss";
import { ReactSVG } from "react-svg";
import Select from "react-select";
import threedotvertical from "../../../assets/images/three-dots-vertical.svg";
import deleteicon from "../../../assets/images/delete-icon.svg";
import viewicon from "../../../assets/images/view-icon.svg";
import circlecheckicon from "../../../assets/images/circle-check-icon.svg";
import DatePicker from "react-date-picker";
import { toggleClass } from "../../../utils/commonUtils";
import useInventoryOrder from "../../../Hooks/useInventoryOrder";
import useVendors from "../../../Hooks/useVendors";
import Loading from "../../../components/LoadingPage/Loading";
import { Vendor } from "../../../redux/vendor/vendorSlice";
import { DropDownValues } from "../../../utils/types";
import moment from "moment";
import { FormikHelpers, useFormik } from "formik";
import { selectCurrentUserId } from "../../../redux/auth/authSlice";
import { useAppSelector } from "../../../redux/hooks";
import React from "react";
import { DeleteConfModel } from "../../../components/DeleteConfModel/deleteConfModel";
import { useModulePermissions, PermissionModule, PermissionIdentifier } from "../../../utils/permissionUtils";
import { toast } from "react-toastify";

const InventoryOrderList = () => {
  const [invOrdList, setInvOrdList] = useState([]);
  const [orderStatusOptions, setOrderStatusOptions] = useState<any>([]);
  const [selectedInvOrd, setSelectedInvOrd] = useState<any>([]);
  const [selectedVender, setSelectedVender] = useState<string>("");
  const {
    InvOrderListAPI,
    InvOrderListLoading,
    InvOrdersLoading,
    InvOrderCreateAPI,
    invOrderCreateLoading,
    orderStatusMasterAPI,
    orderStatusMasterLoading,
    deleteInventoryPurchaseOrderAPI,
    invPurchaseOrderDeleteLoading,
    purchaseOrderCreateAPI,
    purchaseOrderCreateLoading,
    getPurchaseOrderAPI,
    getPurchaseOrderLoading,
    completeInventoryOrderItemAPI,
    invOrderItemMarkCompleteLoading,
  } = useInventoryOrder();
  const [showModal, setShowModal] = useState(false);
  const { getVendorsAPI, getVendorsLoading } = useVendors();
  const [orderList, setOrderList] = useState([]);
  const [currentOrder, setCurrentOrder] = useState<any>();
  const currentUserId = useAppSelector(selectCurrentUserId);
  const [vendorOptions, setVendorOptions] = useState<DropDownValues[]>([]);
  const DynamicInitialValues = {
    orderId: "",
    orderStatus: "",
    startDate: moment()
      .subtract(2, "month")
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
    endDate: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
  };
  const [formInitialValues, setFormInitialValues] =
    useState(DynamicInitialValues);

  const getInvOrdList = () => {
    InvOrderListAPI(selectedVender ? { venderId: selectedVender } : {}).then(
      (res: any) => setInvOrdList(res)
    );
  };

  const itemSelectHandler = (checked: boolean, item: any) => {
    if (checked) {
      setSelectedInvOrd([...selectedInvOrd, item]);
    } else {
      setSelectedInvOrd(selectedInvOrd.filter((x: any) => x.id !== item.id));
    }
  };

  const { handleChange, values, handleSubmit, resetForm } = useFormik({
    initialValues: formInitialValues,
    onSubmit: async (values: any, { setSubmitting }: FormikHelpers<any>) => {
      try {
        getPurchaseOrderAPI(values).then((res) => {
          setOrderList(res);
        });
      } catch (err) { }
      setSubmitting(false);
    },
    enableReinitialize: true,
  });

  const handleCreateInvOrd = async () => {

    if (!isCreatePermitted) {
      toast.error("You don't have permission to create inventory order");
      return;
    }

    await purchaseOrderCreateAPI({
      orderDate: moment().format(),
      orderStatusId: selectedInvOrd[0].orderstatusid,
      vendorId: selectedInvOrd[0].vendorid,
      refNo: "",
      createdBy: currentUserId,
      isActive: true,
      // id:selectedInvOrd[0].id
    }).then(async (res) => {
      const payload = selectedInvOrd.map((x: any) => {
        let data = {
          purchaseOrderId: res.id,
          orderingProductId: x.orderingProductId,
          locationCode: x.locationId,
          isActive: true,
          updatedBy: currentUserId,
          orderQty: x.orderqty,
          orderDate: x.orderdate,
          orderStatusId: x.orderstatusid,
          vendorId: x.vendorid,
          refNo: res.refNo || "",
          createdBy: currentUserId,
          comments: "",
        };
        return {
          ...data,
        };
      });
      await InvOrderCreateAPI(payload).then((res) => {
        getInvOrdList();
        handleSubmit();
      });
    });
  };

  const selectAllHandler = (checked: boolean) => {
    if (checked) {
      setSelectedInvOrd([...invOrdList]);
    } else {
      setSelectedInvOrd([]);
    }
  };
  //DELETE INVENTORY ORDER
  const toggleModal = () => {
    handleSubmit();
    toggleClass();
    setShowModal(!showModal);
  };

  const deleteInventoryOrder = async () => {
    await deleteInventoryPurchaseOrderAPI({ id: currentOrder.id }).then(
      (res: any) => {
        if (res) {
          toggleModal();
        }
      }
    );
  };
  const handleOrderComplete = async (id: string) => {
    await completeInventoryOrderItemAPI({ id: id }).then((res: any) => {
      if (res) {
        handleSubmit();
      }
    });
  };

  const orderNoOptions = useMemo(() => {
    return [
      { value: "All", label: "All" },
      ...orderList.map((order: any) => ({
        value: order?.refNo,
        label: order?.refNo,
      })),
    ];
  }, [orderList]);

  useEffect(() => {
    orderStatusMasterAPI().then((res) => {
      setOrderStatusOptions([
        {
          value: "",
          label: "All",
        },
        ...res?.map((option: any) => {
          return {
            value: option.id,
            label: option.description || "",
          };
        }),
      ]);
    });
    getVendorsAPI({ searchText: "", includeDeleted: false })
      .then((res: Vendor[]) => {
        setVendorOptions([
          {
            value: "",
            label: "All",
          },
          ...res?.map((option: Vendor) => {
            return {
              value: option.id,
              label: option.name || "NA",
            };
          }),
        ]);
      })
      .catch();
    handleSubmit();
  }, []);

  useEffect(() => {
    getInvOrdList();
    setSelectedInvOrd([]);
  }, [selectedVender]);

  const isPermitted = useModulePermissions(PermissionModule.INVENTORY_ORDER);
  const isCreatePermitted = isPermitted(PermissionIdentifier.CREATE_INVENTORY_ORDER);
  const isViewPermitted = isPermitted(PermissionIdentifier.VIEW_INVENTORY_ORDER);
  const isDeletePermitted = isPermitted(PermissionIdentifier.DELETE_INVENTORY_ORDER);
  const isMarkCompletePermitted = isPermitted(PermissionIdentifier.MARK_AS_COMPLETE_INVENTORY_ORDER);
  const isAnyActionPermitted = isViewPermitted || isDeletePermitted || isMarkCompletePermitted;

  return (
    <div className="inventory-order-wrapper">
      {(InvOrderListLoading ||
        getPurchaseOrderLoading ||
        getVendorsLoading ||
        InvOrdersLoading ||
        invOrderCreateLoading ||
        invPurchaseOrderDeleteLoading ||
        invOrderItemMarkCompleteLoading ||
        orderStatusMasterLoading ||
        purchaseOrderCreateLoading) && <Loading />}
      <div className="inventory-order-header">
        <h2>Inventory Order</h2>
      </div>
      <div className="inventory-order-detail-box">
        <Tabs
          defaultActiveKey="invtCreateOrder"
          id="create-order-tab"
          className="mb-3"
        >
          <Tab eventKey="invtCreateOrder" title="Create Order">
            <div className="invt-create-order-content-wrapper">
              <div className="create-order-action-container">
                <div className="create-order-action-box">
                  <label className="form-label">Vendor</label>
                  <Select
                    classNamePrefix="react-select"
                    className="vendorselectbox react-select-container"
                    options={vendorOptions}
                    value={vendorOptions?.find(
                      (option: DropDownValues) =>
                        option.value === selectedVender
                    )}
                    onChange={(e: any) => {
                      setSelectedVender(e.value);
                      getInvOrdList();
                    }}
                  />
                </div>
                <div className="create-order-action-box">
                  <label className="form-label d-block">&nbsp;</label>
                  <Button variant="primary" onClick={handleCreateInvOrd}>
                    Create Order
                  </Button>
                </div>
                <div className="create-order-action-box clear-all-box">
                  <span
                    onClick={() => {
                      setSelectedVender("");
                      getInvOrdList();
                    }}
                  >
                    Clear All
                  </span>
                </div>
              </div>
              <div className="inventory-order-table-wrapper">
                <div className="listing-table-wrapper">
                  <Table responsive="md" hover={true}>
                    <thead>
                      <tr>
                        <th>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            onChange={(e) => selectAllHandler(e.target.checked)}
                            checked={
                              selectedInvOrd.length === invOrdList.length
                            }
                          />
                        </th>
                        <th>Product No</th>
                        <th>Description</th>
                        <th>Location</th>
                        <th>Reorder Level</th>
                        <th>Quantity Oa Hand</th>
                        <th>Order Quantity</th>
                        <th>Unit</th>
                        <th>Vendor Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invOrdList?.map((item: any) => (
                        <tr key={item.id}>
                          <td>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={selectedInvOrd.includes(item)}
                              onChange={(e) =>
                                itemSelectHandler(e.target.checked, item)
                              }
                            />
                          </td>
                          <td>{item.productNo ?? "-"}</td>
                          <td>{item.productDescription ?? "-"}</td>
                          <td>{item.locationName ?? "-"}</td>
                          <td>{item.reorderLevel ?? "-"}</td>
                          <td
                            ref={(el) => {
                              if (el && item?.color) {
                                el.style.setProperty(
                                  "color",
                                  item?.color.toLowerCase(),
                                  "important"
                                );
                              }
                            }}
                          >
                            {item.qtyonhand ?? "-"}
                          </td>
                          <td>{item.orderqty ?? "-"}</td>
                          <td>{item.unitName ?? "-"}</td>
                          <td>{item.defaultvendorname ?? "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </Tab>
          <Tab eventKey="invtorder" title="Orders">
            <div className="order-filter-wrapper">
              <div className="order-filter-item-wrapper">
                <div className="filter-item-box location-filter-item">
                  <label className="form-label">Status</label>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={orderStatusOptions}
                    placeholder="Status"
                    id="orderStatus"
                    name="orderStatus"
                    value={orderStatusOptions?.find(
                      (option: DropDownValues) =>
                        option.value === values.orderStatus
                    )}
                    onChange={(option: any) => {
                      handleChange("orderStatus")(option.value);
                      handleSubmit();
                    }}
                  />
                </div>
                <div className="filter-item-box type-filter-item">
                  <label className="form-label">Order</label>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={orderNoOptions}
                    id="orderId"
                    name="orderId"
                    value={orderStatusOptions?.find(
                      (option: DropDownValues) =>
                        option.value === values.orderId
                    )}
                    onChange={(option: any) => {
                      handleChange("orderId")(option.value);
                      handleSubmit();
                    }}
                  />
                </div>
                <div className="filter-item-box">
                  <label className="form-label">Start Date</label>
                  <DatePicker
                    locale="en-US"
                    format="MM/dd/yyyy"
                    openCalendarOnFocus={false}
                    dayPlaceholder="dd"
                    monthPlaceholder="mm"
                    yearPlaceholder="yyyy"
                    className="form-control"
                    clearIcon={null}
                    calendarIcon={<i className="bi bi-calendar"></i>}
                    showLeadingZeros={true}
                    maxDate={
                      values.endDate ? new Date(values.endDate) : new Date()
                    }
                    value={values.startDate}
                    onChange={(date: any) => {
                      handleChange({
                        target: {
                          name: "startDate",
                          value: moment(date)
                            .utc()
                            .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
                        },
                      });
                      handleSubmit();
                    }}
                  />
                </div>
                <div className="filter-item-box">
                  <label className="form-label">End Date</label>
                  <DatePicker
                    locale="en-US"
                    format="MM/dd/yyyy"
                    openCalendarOnFocus={false}
                    dayPlaceholder="dd"
                    monthPlaceholder="mm"
                    yearPlaceholder="yyyy"
                    className="form-control"
                    clearIcon={null}
                    calendarIcon={<i className="bi bi-calendar"></i>}
                    showLeadingZeros={true}
                    value={values.endDate}
                    maxDate={new Date()}
                    minDate={
                      values.startDate ? new Date(values.startDate) : new Date()
                    }
                    onChange={(date: any) => {
                      handleChange({
                        target: {
                          name: "endDate",
                          value: moment(date)
                            .utc()
                            .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
                        },
                      });
                      handleSubmit();
                    }}
                  />
                </div>
                <div className="filter-item-box clear-all-box">
                  <button
                    type="button"
                    className="clear-filter-btn"
                    onClick={() => {
                      resetForm();
                      handleSubmit();
                    }}
                  >
                    Clear All
                  </button>
                </div>
              </div>
            </div>
            <div className="inventory-order-table-wrapper">
              <div className="listing-table-wrapper">
                <Table responsive="md" hover={true}>
                  <thead>
                    <tr>
                      <th>Order</th>
                      <th>Order Date</th>
                      <th>Status</th>
                      <th>Vendor Name</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderList.map((data: any) => (
                      <tr>
                        <td>{data.refNo}</td>
                        <td>
                          {data.orderDate
                            ? moment(data.orderDate).format("MM/DD/YYYY")
                            : "NA"}
                        </td>
                        <td>
                          <span
                            className={
                              "status-circle " +
                              (data?.orderStatusMaster?.description ===
                                "Completed" || "Active"
                                ? "active"
                                : "inactive")
                            }
                          >
                            {data?.orderStatusMaster?.description}
                          </span>
                        </td>
                        <td>{data?.vendorMaster?.name}</td>
                        <td>
                          <Dropdown>
                            {isAnyActionPermitted && (
                              <Dropdown.Toggle variant="link">
                                <ReactSVG
                                  className="svg-box"
                                  wrapper="span"
                                  src={threedotvertical}
                                />
                              </Dropdown.Toggle>
                            )}
                            <Dropdown.Menu>
                              {isViewPermitted && (
                                <Dropdown.Item href={`/inventory-order-detail/${data.id}`}>
                                  <ReactSVG
                                    className="svg-box"
                                    wrapper="span"
                                    src={viewicon}
                                  />
                                  View Detail
                                </Dropdown.Item>
                              )}
                              {isDeletePermitted && (
                                <Dropdown.Item
                                  onClick={() => {
                                    setCurrentOrder(data);
                                    toggleModal();
                                  }}
                                >
                                  <ReactSVG
                                    className="svg-box"
                                    wrapper="span"
                                    src={deleteicon}
                                  />
                                  Delete Order
                                </Dropdown.Item>
                              )}
                              {isMarkCompletePermitted && (
                                <Dropdown.Item onClick={() => handleOrderComplete(data.id)}>
                                  <ReactSVG
                                    className="svg-box"
                                    wrapper="span"
                                    src={circlecheckicon}
                                  />
                                  Mark as Complete
                                </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
      {/* Delete Inventory Order */}
      <DeleteConfModel
        showModal={showModal}
        toggleModal={toggleModal}
        deleteAction={deleteInventoryOrder}
        modelName={`Inventory Order`}
        recordName={currentOrder?.refNo || ""}
        isDeletePermitted={isDeletePermitted}
      />
    </div>
  );
};

export default InventoryOrderList;
